import { createBasicSelector } from 'util/redux'
import { selectCurrentTicketId } from './selectCurrentTicketId'

export const selectIsComposingNewTicket = createBasicSelector(
  selectCurrentTicketId,
  ticketId => ticketId === 'new'
)
